// extracted by mini-css-extract-plugin
export default {"Greeting":"Greeting_Greeting__1pwKt","Greeting__title":"Greeting_Greeting__title__r--mB","Greeting__text":"Greeting_Greeting__text__zTvb7"};